import { Sine, TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";

export class GalleryHieroglyphRoll extends PIXI.Container {
    private _canvasContainer: PIXI.Container;
    private _canvasMask: PIXI.Graphics;
    private _canvas: PIXI.Sprite;
    private _frame: PIXI.Container;
    private _overlay: PIXI.Sprite;
    private _rolledPerc: number;
    private _cachedWidth: number;

    constructor() {
        super();
        this._rolledPerc = 0;

        this._canvasContainer = new PIXI.Container();
        this._canvasContainer.scale.set(1.065);
        this.addChild(this._canvasContainer);

        this._canvas = HLF.PixiUtils.makeSprite("bg", Constants.SPRITESHEET_HIERO_PREFIX + "02");
        this._canvas.scale.x = -1;
        this._canvasContainer.addChild(this._canvas);

        this._frame = new PIXI.Container();
        this._frame.addChild(HLF.PixiUtils.makeSprite("border-bottom", Constants.SPRITESHEET_HIERO_PREFIX + "00"));
        this._frame.addChild(HLF.PixiUtils.makeSprite("border-top", Constants.SPRITESHEET_HIERO_PREFIX + "00"));
        this._frame.addChild(HLF.PixiUtils.makeSprite("border-left", Constants.SPRITESHEET_HIERO_PREFIX + "00"));
        this._frame.addChild(HLF.PixiUtils.makeSprite("border-right", Constants.SPRITESHEET_HIERO_PREFIX + "00"));
        this._frame.scale.x = -1;
        this._canvasContainer.addChild(this._frame);

        this._overlay = HLF.PixiUtils.makeSprite("empty-pixel", Constants.SPRITESHEET_UI);
        this._overlay.tint = 0xDC780A;
        this._overlay.alpha = 0.3;
        this._overlay.width = this._frame.width;
        this._overlay.height = this._frame.height;
        this._canvasContainer.addChild(this._overlay);

        this._canvasMask = new PIXI.Graphics();
        this._canvasMask.beginFill(0x000000);
        this._canvasMask.drawPolygon(this.makeMaskShape());
        this._canvasMask.endFill();
        this._canvasMask.scale.copy(this._canvasContainer.scale);
        this.addChild(this._canvasMask);
        this.mask = this._canvasMask;

        this._cachedWidth = this.width;

        // this.alpha = 0.2;
    }

    public get rolledPerc(): number {
        return this._rolledPerc;
    }

    public set rolledPerc(pValue: number) {
        this._rolledPerc = pValue;
        this._canvasMask.position.x = ((this._cachedWidth * 0.45) - this._canvasMask.width) * this._rolledPerc;
        this._canvasContainer.x = 2 * ((this._cachedWidth * 0.5) * this._rolledPerc);
    }

    public playOpenAnimation(): TimelineLite {
        const timeline: TimelineLite = new TimelineLite();
        timeline.to(this, 0.8, {
            rolledPerc: 1,
            ease: Sine.easeInOut,
        });
        return timeline;
    }

    private makeMaskShape(): PIXI.Point[] {
        const angleDelta: number = Math.PI * 0.2;
        const angleStart: number = (Math.PI - angleDelta) / 2;
        const width: number = 120;
        const ridgeHeight: number = 6;
        const height: number = this._canvas.height - 10 - 2 * ridgeHeight;
        const ridgeSmoothness: number = 10;
        const cosMin: number = Math.cos(angleStart);
        const cosDelta: number = Math.cos(angleStart + angleDelta) - cosMin;
        const sinMin: number = Math.sin(angleStart);
        const sinDelta: number = Math.sin(angleStart + angleDelta / 2) - sinMin;

        const maskShape: PIXI.Point[] = new Array<PIXI.Point>();
        let perc: number;
        let percX: number;
        let percY: number;
        for (let i = 0; i < ridgeSmoothness; ++i) {
            perc = i / (ridgeSmoothness - 1);
            percX = (Math.cos(angleStart + angleDelta * perc) - cosMin) / cosDelta;
            percY = (Math.sin(angleStart + angleDelta * perc) - sinMin) / sinDelta;
            maskShape.push(new PIXI.Point(
                width * percX,
                -height * 0.5 - ridgeHeight * percY,
            ));
        }
        for (let i = 0; i < ridgeSmoothness; ++i) {
            perc = i / (ridgeSmoothness - 1);
            percX = (Math.cos(angleStart + angleDelta * perc) - cosMin) / cosDelta;
            percY = (Math.sin(angleStart + angleDelta * perc) - sinMin) / sinDelta;
            maskShape.push(new PIXI.Point(
                width * (1 - percX),
                height * 0.5 + ridgeHeight * percY,
            ));
        }
        return maskShape;
    }
}
